const CapitalizeTextDirective = {
  bind: el => {
    let text = el.textContent;
    text = text.toLowerCase();
    // a-Z and accent characters like MúNich
    text = text.replace(/(?:^|\s)\S/g, l => (l ? l.toUpperCase() : ''));
    el.textContent = text.includes('Fc') ? text.replace('Fc', 'FC') : text;
  },
};

export default CapitalizeTextDirective;
